import { ICommand } from 'core-ts-types';
import { TodosContentService } from '../../data/services/my_todos_content_service';
import { TodoDateRangeService } from '../../data/services/todo_date_range_service';
import { TodoRefreshService } from '../../data/services/todo_refresh_service';

export class TodosContentController {
  private isRefreshing: boolean = false;

  constructor(
    private ngTodosContentService: TodosContentService,
    private ngTodoRefreshService: TodoRefreshService,
    private ngTodoDateRangeService: TodoDateRangeService,
    private loadAllPathStatusCommand: ICommand,
    private loadAllReminderDateRangeCommand: ICommand,
    private loadStaffTodoCommand: ICommand,
    private $q: ng.IQService
  ) {
    this.refreshTodos();
  }

  get showMoreText(): string {
    const { start, end } = this.ngTodoDateRangeService.getShowMoreDateRangeText();
    return `Show To-Dos from ${start} to ${end}`;
  }

  refreshTodos(): void {
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      const dateRange = this.ngTodoDateRangeService.getCurrentDateRange();
      this.$q
        .all([
          this.loadAllPathStatusCommand(dateRange),
          this.loadAllReminderDateRangeCommand(dateRange),
          this.loadStaffTodoCommand(dateRange)
        ])
        .finally(() => {
          this.ngTodosContentService.loadTodosAndReminders();
          this.isRefreshing = false;
        });
    }
  }
}

export class TodosContentComponent implements angular.IComponentOptions {
  public templateUrl: string = 'capability-ng-todos/src/components/my_todos_content/my_todos_content.html';
  public controller: any = TodosContentController;
  public controllerAs: string = '$ctrl';
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-todos/src/components/my_todos_content/my_todos_content_controller.ts